import { Body16, Button, Modal } from "@/components";
import useJob from "@/modules/hooks/useJob";
import { useForcePrepaidIds } from "@/modules/routes";
import polyglot from "@/utils/polyglot";
import { useEffect, useMemo } from "react";

const DeferredPaymentConfirmationModal = ({ isOpen, onClose }) => {
  const { pendingPrepaidIds, pendingPrepaids } = useJob();
  const forcePrepaidIds = useForcePrepaidIds();

  const creditCard = useMemo(
    () =>
      pendingPrepaids.find(
        (offer) => offer?.prepayment_informations?.mangopay_card_alias
      ),
    [pendingPrepaids]
  );

  const totalAmount = useMemo(
    () => pendingPrepaids?.reduce((acc, offer) => acc + offer.price, 0),
    [pendingPrepaids]
  );

  const handleConfirm = () => {
    forcePrepaidIds.mutate(pendingPrepaidIds);
  };

  useEffect(() => {
    if (forcePrepaidIds.isSuccess) {
      onClose();
    }
  }, [forcePrepaidIds.isSuccess]);

  return (
    <Modal.XSmall isOpen={isOpen} onClose={onClose}>
      <Modal.Item.Header onClose={onClose}>
        <Modal.Item.Title>
          {polyglot.t("job.prepaid_trigger_title")}
        </Modal.Item.Title>
      </Modal.Item.Header>
      <Modal.Item.Wrapper>
        <Body16>
          {polyglot.t("job.prepaid_trigger_description_amount_compact", {
            count: pendingPrepaids?.length,
            amount: polyglot.toSmartCurrency(totalAmount),
          })}
        </Body16>
      </Modal.Item.Wrapper>
      <Modal.Item.Footer columns>
        <Button.Large
          onClick={handleConfirm}
          isLoading={forcePrepaidIds.isLoading}
          block
        >
          {polyglot.t("common.confirm")}
        </Button.Large>
      </Modal.Item.Footer>
    </Modal.XSmall>
  );
};

export default DeferredPaymentConfirmationModal;
